$(window).load(function() {
  console.log('window load');

  const tolstoy_stories = $('tolstoy-stories .tolstoy-stories-main-container').length;
  console.log(tolstoy_stories);
  if(tolstoy_stories == 0){
     $('.tolstoy-stories-wrapper h2').hide();
  }
  // Change text After page
  setTimeout(function() {
    let sr = $('square-placement')[0].shadowRoot; 
    var afterpay_main_text_html = $(sr).find('.afterpay-main-text').html();
    afterpay_main_text_html = afterpay_main_text_html.split('<strong>');
    //afterpay_main_text_html = afterpay_main_text_html[1].split('</strong>');
    //afterpay_main_text_html = afterpay_main_text_html[0];
    //$(sr).find('.afterpay-main-text').html('Pay in 4 payments of <strong>'+afterpay_main_text_html[1]);
    //$(sr).find('button.afterpay-logo').html(' Afterpay.').css('text-decoration','underline').css('font-family',"'Montserrat',sans-serif").css('font-size','12px').css('text-align','left').css('vertical-align','inherit');

    $(sr).find('.afterpay-main-text').html(`or 4 fortnightly payments of `+afterpay_main_text_html[1]+`<svg style="margin-bottom: -14px;margin-left: -13px;margin-right: -8px;width: 90px;" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" width="98" height="36" class="compact-badge-logo" aria-hidden="true" viewBox="0 0 100 21">
                            <g class="afterpay-logo-badge-lockup">
                              <path d="M85.05 6.37L82.88 5.1l-2.2-1.27a2.2 2.2 0 00-3.3 1.9v.29c0 .16.08.3.22.38l1.03.58c.28.16.63-.04.63-.37v-.67c0-.34.36-.54.65-.38l2.02 1.16 2 1.15c.3.16.3.58 0 .75l-2 1.15-2.02 1.16a.43.43 0 01-.65-.38v-.33a2.2 2.2 0 00-3.28-1.9l-2.2 1.26-2.19 1.25a2.2 2.2 0 000 3.8l2.18 1.25 2.2 1.27a2.2 2.2 0 003.3-1.9v-.3c0-.15-.09-.3-.23-.37L78.02 14a.43.43 0 00-.64.37v.67c0 .34-.36.54-.65.38l-2-1.16-2-1.15a.43.43 0 010-.75l2-1.15 2-1.16c.3-.16.65.05.65.38v.33a2.2 2.2 0 003.3 1.9l2.2-1.26 2.17-1.25a2.2 2.2 0 000-3.8z"></path>
                              <path d="M70.77 6.78l-5.1 10.53h-2.12l1.91-3.93-3-6.6h2.17l1.93 4.42 2.1-4.42h2.11z"></path>
                              <path d="M19.8 10.5c0-1.24-.92-2.12-2.04-2.12s-2.03.9-2.03 2.14c0 1.23.91 2.14 2.03 2.14s2.03-.88 2.03-2.14m.02 3.74v-.97a3 3 0 01-2.36 1.09c-2.05 0-3.6-1.65-3.6-3.86 0-2.2 1.61-3.87 3.65-3.87.95 0 1.76.42 2.31 1.08v-.95h1.84v7.48h-1.84z"></path>
                              <path d="M30.6 12.6c-.65 0-.84-.24-.84-.87V8.4h1.2V6.78h-1.2V4.96h-1.88v1.82h-2.43v-.74c0-.63.24-.87.9-.87h.42V3.72h-.9c-1.56 0-2.3.5-2.3 2.07v1h-1.04V8.4h1.04v5.85h1.88V8.4h2.43v3.66c0 1.53.6 2.19 2.11 2.19h.97V12.6h-.37z"></path>
                              <path d="M37.35 9.85c-.13-.97-.93-1.56-1.86-1.56-.92 0-1.7.57-1.88 1.56h3.74zM33.6 11c.13 1.1.93 1.74 1.93 1.74.8 0 1.4-.37 1.76-.97h1.94c-.45 1.58-1.87 2.6-3.74 2.6a3.68 3.68 0 01-3.85-3.85 3.78 3.78 0 013.9-3.9 3.74 3.74 0 013.8 4.38H33.6z"></path>
                              <path d="M51.35 10.5c0-1.2-.9-2.12-2.03-2.12-1.12 0-2.03.9-2.03 2.14 0 1.23.9 2.14 2.03 2.14 1.12 0 2.03-.93 2.03-2.14m-5.92 6.79V6.78h1.84v.97a2.97 2.97 0 012.36-1.1c2.02 0 3.6 1.65 3.6 3.85s-1.6 3.87-3.65 3.87a2.9 2.9 0 01-2.26-1v3.93h-1.9.01z"></path>
                              <path d="M59.86 10.5c0-1.24-.9-2.12-2.03-2.12-1.12 0-2.04.9-2.04 2.14 0 1.23.92 2.14 2.04 2.14s2.03-.88 2.03-2.14m.02 3.74v-.97a3 3 0 01-2.36 1.09c-2.05 0-3.6-1.65-3.6-3.86 0-2.2 1.61-3.87 3.64-3.87.96 0 1.76.42 2.32 1.08v-.95h1.84v7.48h-1.84z"></path>
                              <path d="M42.11 7.5s.47-.86 1.62-.86c.5 0 .8.17.8.17v1.9s-.69-.42-1.32-.33c-.64.09-1.04.67-1.04 1.45v4.42h-1.9V6.78h1.84v.73z"></path>
                            </g>
                          </svg>`).css('font-size','12px');
    $(sr).find('button.afterpay-logo').html(`<span style="color:#000;">Info.</span>`).css('text-decoration','underline').css('font-family',"'Montserrat',sans-serif").css('font-size','12px').css('text-align','left').css('vertical-align','middle').css('width','auto').css('color','#000');
    
    
    $(sr).find('.afterpay-link').hide();
  }, 500)
  
  $(".fs-slider_v2_5 .fs-wrapper .fs-timeline-entry").click(function(){
    console.log('open video popup');
    var myVar = setInterval(myTimer, 500);
    function myTimer() {
      if( $('.fs-slider_v2_5 .fs-detail-outer-container').length ) {
        $('.fs-slider_v2_5 .fs-detail-outer-container video').get(0).play();
        clearInterval(myVar);

        $(".fs-slider_v2_5 .fs-detail-container .fs-detail-nav-button").click(function(){
          console.log('click nav open video popup');
          var myVar = setInterval(myTimer, 500);
          function myTimer() {
            if( $('.fs-slider_v2_5 .fs-detail-outer-container video').length ) {
              $('.fs-slider_v2_5 .fs-detail-outer-container video').get(0).play();
              clearInterval(myVar);
            }
          }
        });
        
      }
    }
  });
  
 
});

function isValidEmailAddress(emailAddress) {
  var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return pattern.test(emailAddress);
}

function register($form) {
  $.ajax({
    type: 'POST',
    url: '//lasaona.com/pilgrimclothing/generate_discount/call-action.php',
    data: {"email":$form.find('input[type=email]').val(),"type":"welcome"},
    dataType : 'json',
    encode : true,
    error       : function(err) {
      $("#ajax2").css('color','red');
      $("#ajax2").html("Could not connect to the registration server. Please try again later.");
    },
    success     : function(result) {
      if(result.success){
        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize()+'&COUPON='+result.message,
          cache       : false,
          dataType    : 'json',
          contentType: "application/json; charset=utf-8",
          error       : function(err) { 
            $("#ajax2").css('color','red');
            $("#ajax2").html("Could not connect to the registration server. Please try again later.");
          },
          success     : function(data) {
            if (data.result != "success") 
            {
              if (data.msg.indexOf("is already subscribed") >= 0)
              {
                var text_msg = data.msg.split('is already subscribed to list Pilgrim Clothing');
                $("#ajax2").css('color','red');
                $("#ajax2").html('<a style="color:#0000FF;text-decoration: underline;cursor: pointer;">'+ data.msg+'</a>');
              }
              else
              {    
                $("#ajax2").css('color','red');
                $("#ajax2").html(data.msg);
              }            
            } 
            else 
            {
              $("#thankyou_pop").css("display",'block');
              $("#close-form").css("display",'none');
            }
          }
        });
      }else{
        $("#ajax2").css('color','red');
        $("#ajax2").html("Your email has been received the code in the past.");
      }
    }
  });
}

function register_mailchimp($form) {
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { 
        $("#ajax").css('color','red');
        $("#ajax").html("Could not connect to the registration server. Please try again later.");
      },
      success     : function(data) {
        if (data.result != "success") 
        {
          if (data.msg.indexOf("is already subscribed") >= 0)
          {
            var text_msg = data.msg.split('is already subscribed to list Pilgrim Clothing') 
            $("#ajax").css('color','red');
            $("#ajax").html('<a style="text-decoration: underline;cursor: pointer;">'+ text_msg[0]+'</a> is already subscribed');
          }
          else
          {    
            $("#ajax").css('color','red');
            $("#ajax").html(data.msg);
          }            
        } 
        else 
        {
          $("#ajax").css('color','green');
          $("#ajax").html("Thank you for subscribing, your discount has been sent to your inbox!");
        }
      }
    });
  }


var myVarSee = setInterval(myTimerSee, 500);
function myTimerSee() {
  if( $('tolstoy-stories .tolstoy-stories-main-container').length ) {
    console.log('has tolstoy-stories');
    $('.js-popup-button-see-it').addClass('active');
    clearInterval(myVarSee);
  }
}

var myVarIchange = setInterval(myTimerIChange, 500);
function myTimerIChange() {
  if( $('.iChangeApp--modal').length ) {
    console.log('has iChangeApp--modal');
    $('.iChangeApp--modal #ica--modal-emails').prop('checked', false);
    clearInterval(myVarIchange);
  }
}


$(document).ready(function(){

   $(".js-popup-button-see-it").click(function(){
    console.log('222 it');
    //window.tolstoyWidget.recreate('vamb43jdtmq90');
    //window.tolstoyWidget.show();
    console.log($('tolstoy-stories a').text());
    $('a[data-tolstoy-element="tolstoy-stories-on-you-button-vamb43jdtmq90"]').click();
    $("tolstoy-stories a")[0].click();
    $('tolstoy-stories a').trigger('click');

    window.tolstoyWidget.start();
    window.tolstoyWidget.vamb43jdtmq90.init();
  });
  
  /* iequalchange */
  if ($('#i-change').length > 0) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        var obj = JSON.parse(xhttp.response);
        console.log(obj);
        document.getElementById("raised-total").innerHTML = "$" + obj.donation;	 
      }
    };
    var url = "https://share.iequalchange.com/public/api/donations/livetotal?logo=1";
    xhttp.open("GET", url, true);   // async
    xhttp.setRequestHeader ("Authorization", "Basic NDk2Oj9lXEZBR353MiRjdS42YXQ=");
    xhttp.setRequestHeader ("Accept", "*/*");
    xhttp.send();
  }

  /* gift card page */
  if ($('#gift-card-page').length > 0) {
    console.log('gift card page');
      
  }
  
  /*START CUSTOM JS*/
  console.log($('#slide_home').length);
  if($('#slide_home').length > 0){
    $('#slide_home').owlCarousel({
      autoplay:true,
      autoplayTimeout:10000,
      loop:true,
      margin:10,
      nav:true,
      dots: true,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    })

    $('#slide_mb').owlCarousel({
      autoplay:true,
      autoplayTimeout:10000,
      loop:true,
      margin:10,
      nav:true,
      dots: false,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    })
  }


  setTimeout(function() {
    $('#slider_home-hero').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
      mouseDrag:false,
    nav:false,
    dots: false,
       touchDrag: false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      1000:{
        items:1
      }
    }
  })
},1000);
  
  /* Newsletter Form */
  var $form = $('#mc-embedded-subscribe-form');
    $('.newsletter').click(function(){
      var validEmail = isValidEmailAddress($('#mail').val());
      if(validEmail)
      {
        $("#ajax").html("");
        $(".wrrap-loading").show();
        
        var email = $('#mail').val();
        var type = 'welcome';
        var postData = {
              "email":email,
              "type":type
            }
        $.ajax({
          type      : 'POST',
          url		: 'https://lasaona.com/pilgrimclothing/generate_discount/call-action.php?email='+email+'&type='+type,
          data      : postData,
          dataType  : 'json',
          encode    : true,
          success: function( data, textStatus, jQxhr ){
            //console.log( data );
          },
          error: function( jqXhr, textStatus, errorThrown ){
            console.log( errorThrown );
            $("#ajax").css('color','red');
        	$("#ajax").html("Could not connect to the registration server. Please try again later.");
            $(".wrrap-loading").hide();
          }
        }).done(function(data) {
			$('#generate-coupon').val(data.message);
            $(".wrrap-loading").hide();
          	setTimeout(function(){ register_mailchimp($form); }, 250);
        }); 
        
      }else{
        $("#ajax").html("Please enter a valid email address");
        $('#mail').focus();
      }
      return false;
    });
  
  /* Popup Subscription */
  var $form2 = $('#mc-embedded-subscribe-form2');

  $form2.find('input[type=button]').click(function(){
    if($form2.find('input[type=email]').val() != ""){
      $("#ajax2").html("");
      register($form2);
    }else{
      $("#ajax2").html("Please enter a valid email address");
      $('#PopupSubscribe').focus();
    }
    return false;
  });
  
  /* Contact Page */
  console.log($('#contact-us').length);
  if($('#contact-us').length > 0){
    $('#subject').fancySelect({
      showText: true,
      showImages: false
    });

    var mySelect = $('#subject');
    var subject = $(this).val();

    mySelect.fancySelect().on('change.fs', function() {
      $(this).trigger('change.$');
      var subject = $(this).val();
      $(".trigger").removeClass("required");
      if(subject == "Stock Enquiries"){
        $('#stock-enquiries').addClass("show");
        $('.trigger.selected').addClass("show");
      }else{
        $('#stock-enquiries').removeClass("show");
        $(".trigger.selected").removeClass("show");
      }
    }); // trigger the DOM's change event when changing FancySelect

    var isMobile = navigator.userAgent.match(/iPad|iPhone|Android|Blackberry/i);
    if(isMobile){
      $('#contact_form').append( '<input type="hidden" name="contact[mobile]" value="1" />' );
    }


    $('#contact_form').submit(function(e) {

      e.preventDefault();

      var mySelect = $('#subject');
      var subject = $(this).val();      

      mySelect.fancySelect().on('change.fs', function() {
        $(this).trigger('change.$');
        var subject = $(this).val();
        $(".trigger").removeClass("required");
        if(subject == "Stock Enquiries"){
          $('#stock-enquiries').addClass("show");
          $('.trigger.selected').addClass("show");
        }else{
          $('#stock-enquiries').removeClass("show");
          $(".trigger.selected").removeClass("show");
        }
      });

      var subject = $('#subject').val();
      if(subject == ""){

        $(".trigger").addClass("required");
        return false;

      }else{

        $(".trigger").removeClass("required");
        //this.submit(); // use the native submit method of the form element

        $form = $(this);      
        var formData = $form.serialize();
        console.log(formData);
        $form.find('.submit_btn').attr("disabled","disabled").val('SENDING...'); 
        $.ajax({
          type      : 'POST',
          url		: 'https://lasaona.com/pilgrimclothing/submit.php?function=contact-form',
          data      : formData,
          dataType  : 'json',
          encode    : true
        }).done(function(data) {
          if(data.success){
            document.getElementById("contact_form").reset();
            $('.response-messenger').show();

          }else{
            alert(data.message);
          }
          $form.find('.submit_btn').removeAttr("disabled").val('SEND ENQUIRY');
        });

      }

    });
  }
    

    $(".footer__menus li.has-dropdown span").click(function () {
      console.log('222');
      $this = $(this);
  	  $target =  $this.next();
      if($target.hasClass('active')){
        $target.removeClass('active').slideUp(300);
      } else {
        $target.addClass('active').slideDown(300); 	 
      }
    });
  

});

$('.tabs__content.prdDescr').html(function(i,h){
    return h.replace(/&nbsp;/g,'');
});


$(function () {

  $(".subsub-dropdown").css("display", "none");
 
  $(".sub_link_custom").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

 $(document).ready(function() {
    $(window).scroll(function() {
        $(".announcement__bar-new").addClass("active");
        var scroll = $(window).scrollTop();
 
        if (scroll <= 10) {
          $(".announcement__bar-new").removeClass("active");
        }
      });

  });

  
  /*END CUSTOM JS*/